import { render } from "./ContractArea.vue?vue&type=template&id=4e8fb1d2&scoped=true&ts=true"
import script from "./ContractArea.vue?vue&type=script&lang=ts"
export * from "./ContractArea.vue?vue&type=script&lang=ts"

import "./ContractArea.vue?vue&type=style&index=0&id=4e8fb1d2&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8fb1d2"]])

export default __exports__